import React from 'react';
import { Icon } from '@saviynt/design-system';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import './ARSTimeLineIconLarge.css';

const KINDS = {
  fill: 'fill',
  outline: 'outline',
  none: 'none',
};

const ICONS = {
  check: 'check',
  reject: 'reject',
};

function ARSTimeLineIconLarge({ kind, head, tail, iconKind }) {
  const iconClass = classnames(
    'ARSTimeLineIconLarge-icon',
    head === KINDS.fill
      ? 'ARSTimeLineIconLarge-icon--fill'
      : 'ARSTimeLineIconLarge-icon--outline',
    kind === 'critical' && 'ARSTimeLineIconLarge-icon--critical'
  );
  const lineClass = classnames(
    'ARSTimeLineIconLarge-line',
    tail === KINDS.fill
      ? 'ARSTimeLineIconLarge-line--fill'
      : 'ARSTimeLineIconLarge-line--outline',
    tail === KINDS.none && 'ARSTimeLineIconLarge-line--none',
    kind === 'critical' && 'ARSTimeLineIconLarge-line--critical'
  );

  return (
    <div className='ARSTimeLineIconLarge'>
      <div className={iconClass}>
        {head === KINDS.fill && (
          <Icon
            kind={iconKind === ICONS.reject ? 'Reject' : 'check'}
            color='neutral-000'
            size='xxSmall'
          />
        )}
      </div>
      <div className={lineClass}>
        {tail === KINDS.outline &&
          [...Array(10).keys()].map((key) => (
            <div
              key={key}
              className={`ARSTimeLineIconLarge-lineChild--outline ${
                kind === 'critical'
                  ? 'ARSTimeLineIconLarge-lineChild--critical'
                  : ''
              }`}
            />
          ))}
      </div>
    </div>
  );
}

ARSTimeLineIconLarge.propTypes = {
  kind: PropTypes.string,
  head: PropTypes.oneOf(Object.values(KINDS)),
  tail: PropTypes.oneOf(Object.values(KINDS)),
  iconKind: PropTypes.oneOf(Object.values(ICONS)),
};

ARSTimeLineIconLarge.defaultProps = {
  kind: 'info',
  head: KINDS.fill,
  tail: KINDS.fill,
  iconKind: ICONS.check,
};

export default ARSTimeLineIconLarge;
